import {
  Avatar,
  Box,
  Divider,
  Flex,
  Input,
  SimpleGrid,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import moment from "moment-timezone";
import { GiChoice } from "react-icons/gi";
import { IoInformationCircleSharp } from "react-icons/io5";
import { removeUnderscore } from "../../../utils/removedUnderScore";
import LeftSidePreview from "./LeftSidePreview";
import RightSideBasicInfo from "./RightSideBasicInfo";
const MergeDuplication = ({
  records,
  mergedData,
  setMergedData,
  setHighlighted,
  highlighted,
}) => {
  const handleFieldChange = (field, value) => {
    setMergedData((prev) => ({ ...prev, [field]: value }));

    setHighlighted((prev) => ({ ...prev, [field]: true }));
    setTimeout(() => {
      setHighlighted((prev) => ({ ...prev, [field]: false }));
    }, 1000);
  };

  const handleAddressChange = (index, field, value) => {
    setMergedData((prev) => {
      const updatedAddresses = [...prev.ADDRESS];
      updatedAddresses[index][field] = value;
      return { ...prev, ADDRESS: updatedAddresses };
    });
  };

  const handleSelectAddress = (address, index) => {
    const oldMap = new Map([...mergedData?.previewAddress]);
    oldMap.set(index, address);
    setMergedData((prev) => ({
      ...prev,
      previewAddress: oldMap,
    }));
  };

  const handleRemoveAddress = (index) => {
    const oldMap = new Map([...mergedData?.previewAddress]);
    oldMap.delete(index);
    setMergedData((prev) => ({
      ...prev,
      previewAddress: oldMap,
    }));
  };

  return (
    <Box p={1}>
      <Flex h="80vh">
        <Box
          w="40%"
          p={1}
          borderRight="1px solid #ccc"
          borderRadius="md"
          overflowY="auto"
          maxH="80vh"
        >
          <LeftSidePreview
            mergedData={mergedData}
            handleRemoveAddress={handleRemoveAddress}
            highlighted={highlighted}
            setMergedData={setMergedData}
          />
        </Box>
        {/* Right Side Input Section */}
        <Box w="60%" pl={2} overflowY="auto" maxH="80vh">
          <Text
            fontWeight="500"
            fontSize="md"
            mb={2}
            display="flex"
            alignItems="center"
            gap={1}
          >
            Basic Information
            <Tooltip
              label="You have to select value to merge!"
              placement="top"
              hasArrow
            >
              <span>
                <IoInformationCircleSharp
                  fontSize="16px"
                  cursor="pointer"
                  color="#3c1514"
                />
              </span>
            </Tooltip>
          </Text>
          <RightSideBasicInfo
            records={records}
            mergedData={mergedData}
            handleFieldChange={handleFieldChange}
          />

          {/* Address Section */}
          <Box mt={1}>
            <Divider my={1} />
            <Text fontWeight={500} fontSize="md" mb={1}>
              Address
            </Text>
            <Text color="red" fontWeight={500} fontSize="xs">
              You need to select atleast one address to submit
            </Text>
            <SimpleGrid columns={2} spacing={2}>
              {mergedData?.ADDRESS?.map((address, addrIndex) => {
                console.log("=====add", address);
                return (
                  <Box
                    key={addrIndex}
                    borderWidth="1px"
                    borderRadius="lg"
                    p={1}
                    boxShadow="sm"
                    bg="gray.50"
                  >
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      px={5}
                    >
                      <Flex alignItems="center" gap={2}>
                        <Avatar
                          size="xs"
                          name={address.sourceName || "Unknown Person"}
                          bg={address.avatarColor}
                          color="white"
                          fontSize="8px"
                        />
                        <Box>
                          <Text fontSize="10px" fontWeight="500">
                            {address.sourceName}
                          </Text>
                        </Box>
                      </Flex>

                      <GiChoice
                        size={20}
                        color="green"
                        cursor="pointer"
                        onClick={() => handleSelectAddress(address, addrIndex)}
                      />
                    </Flex>

                    <SimpleGrid columns={2} spacing={1}>
                      {Object.keys(address)
                        .filter(
                          (item) =>
                            !["sourceName", "sourcePersonId"].includes(item)
                        ) // Exclude metadata
                        .map((item) => (
                          <Box key={item} textAlign="left" ml={4} fontSize="sm">
                            <Text fontSize="10px" fontWeight={500} mb="4px">
                              {removeUnderscore(item)}
                            </Text>
                            <Input
                              type={
                                item === "END_DATE" || item === "START_DATE"
                                  ? "date"
                                  : "text"
                              }
                              w="100%"
                              size="sm"
                              fontSize="10px"
                              fontWeight="normal"
                              ringColor="gray"
                              borderRadius="md"
                              bg="white"
                              border="1px solid gray"
                              value={
                                item === "END_DATE" || item === "START_DATE"
                                  ? moment(address[item], "YYYYMMDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  : address[item] || ""
                              }
                              onChange={(e) => {
                                const newValue =
                                  item === "END_DATE" || item === "START_DATE"
                                    ? moment(
                                        e.target.value,
                                        "YYYY-MM-DD"
                                      ).format("YYYYMMDD")
                                    : e.target.value;

                                handleAddressChange(addrIndex, item, newValue);
                              }}
                            />
                          </Box>
                        ))}
                    </SimpleGrid>
                  </Box>
                );
              })}
            </SimpleGrid>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default MergeDuplication;
